// Разбор тела ошибочного ответа backend в человекочитаемое сообщение — 1:1 копия
// miniapp/src/api/errorMessage.ts (тот же backend, тот же формат ошибок FastAPI
// {"detail": "..."}), продублировано, а не импортировано напрямую — admin/ и miniapp/ два
// независимых фронтенда без общего пакета (см. docs/PLAN.md Этап 6).

export function extractErrorMessage(body: string, fallback: string): string {
  const trimmedFallback = body || fallback;
  try {
    const parsed: unknown = JSON.parse(body);
    if (
      parsed &&
      typeof parsed === "object" &&
      typeof (parsed as { detail?: unknown }).detail === "string"
    ) {
      return (parsed as { detail: string }).detail;
    }
  } catch {
    // не JSON (например, 502 от nginx с HTML-страницей) — оставляем как есть
  }
  return trimmedFallback;
}
